module.exports = __webpack_public_path__ + "static/media/icon-quarterlyreports.7ff688f9.svg";